export const MAX_CANVAS_SIZE = 850;

const propoprtions = {
  new_cards: 117 / 90,
  russian_cards: 389.333 / 266.667,
  pocker_cards: 389 / 267,
};

export const LAID_SIZE = 8;
export const CARD_PROPORTION = propoprtions.new_cards;

export const CARD_DESKTOP_SIZE = 11;
export const DESKTOP_OFFSET = 2;
export const OFFSET_BETWEEN_CARDS = 1;
export const SEPARATE_DESKTOP_SIZE = 100 - ( (CARD_DESKTOP_SIZE * LAID_SIZE) + ((LAID_SIZE - 1) * OFFSET_BETWEEN_CARDS) + (DESKTOP_OFFSET * 2) );
